import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ee3ulfd69w: FaireBrandEntity = {
  token: "b_ee3ulfd69w",
  type: "brand",
  name: "Funky Junque",
  avatarUrl:
    "https://cdn.faire.com/fastly/06d7f4eaebaba61b66f169cc6197661016de7dcb085fe579f85cb7330780ade5.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/d821e5fb42b60ad66053e76a8ae619fc5c7fd1c71c48c6190d62b24298d1d879.png",
  logoUrl:
    "https://cdn.faire.com/fastly/06d7f4eaebaba61b66f169cc6197661016de7dcb085fe579f85cb7330780ade5.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d821e5fb42b60ad66053e76a8ae619fc5c7fd1c71c48c6190d62b24298d1d879.png",
  location: "Northbrook, IL, USA",
  minimumOrderDollars: 85,
  rating: 4.9,
  reviewCount: 291,
  isTopShop: true,
  isInsider: true,
  description:
    "Funky Junque was founded in 2001 with a clear mission: create stylish, high-quality fashion accessories at prices customers feel good about buying—and retailers feel confident stocking.\n\nFor more than two decades, the brand has grown by focusing on what truly drives retail success: great design, reliable quality, and products people reach for every day. Today, Funky Junque offers a wide assortment of best-selling hats, baseball caps, trucker hats, beanies, scarves, gloves, and giftable accessories designed for every season. \n\nRetailers value Funky Junque for its trend-forward designs, dependable quality, and strong price points. Our collections are easy to merchandise and appeal to women, men, kids, and babies, making them natural additions to boutiques, gift shops, and lifestyle stores.\n\nMore than twenty years after its founding, Funky Junque continues to follow the same guiding principle that built the brand: create accessories customers love to wear—and that retailers can sell with confidence.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:44.328Z",
    importedBy: "entity-db-cli",
  },
};
